import { escapeFormulaQuotedValue } from "./customFormulaQuotedValue";

const trailingOperatorPattern = /[+\-*/(,]$/u;

const trimTrailingWhitespace = (value: string): string => value.replace(/\s+$/u, "");

const shouldAppendFieldDirectly = (formula: string): boolean => trailingOperatorPattern.test(formula);

const getSpacerAfterTrailingToken = (formula: string): string => {
  const lastToken = formula[formula.length - 1];
  if (lastToken === "(") {
    return "";
  }

  if (lastToken === " ") {
    return "";
  }

  return " ";
};

const appendFieldAfterToken = (formula: string, fieldToken: string): string => {
  return `${formula}${getSpacerAfterTrailingToken(formula)}${fieldToken}`;
};

export const insertFieldIntoFormula = (formulaInput: string, fieldCaption: string): string => {
  const fieldToken = `"${escapeFormulaQuotedValue(fieldCaption)}"`;
  const trimmedFormula = trimTrailingWhitespace(formulaInput);

  if (trimmedFormula.length === 0) {
    return fieldToken;
  }

  if (shouldAppendFieldDirectly(trimmedFormula)) {
    return appendFieldAfterToken(trimmedFormula, fieldToken);
  }

  return `${trimmedFormula} + ${fieldToken}`;
};

export const insertFunctionIntoFormula = (formulaInput: string, insertText: string): string => {
  const trimmedFormula = trimTrailingWhitespace(formulaInput);

  if (trimmedFormula.length === 0) {
    return insertText;
  }

  if (shouldAppendFieldDirectly(trimmedFormula)) {
    return appendFieldAfterToken(trimmedFormula, insertText);
  }

  return `${trimmedFormula} + ${insertText}`;
};
